<template>
    <div>
        <app-select
            label="Hintergrund- und Schriftfarbe"
            :data-source="'tecpage.user.menus.' + menuId + '.appearance.color'"
            :options="getActiveMenuAppearanceColors"
            :data-default="{ type: 'random' }"
            :custom-class="'appearance-color'"
            hide-clear
            required
        ></app-select>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Select from '@/components/fields/simple/Select.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'getActiveMenuAppearanceColors'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R013'),
            help: this.$helpers.uiText('R014'),
            removeText: this.$helpers.uiText('R026'),
            showGlobal: false
        });
    },
    props: {
        menuId: String
    },
    components: {
        'app-select': Select
    }
};
</script>
